import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Formik } from "formik";
import { LabelWithValue } from "../../../document/components/label-with-value";
import { GroupsOfficeService } from "../../../../services/group365/groupOffice.service";
import { CreateNotification } from "../../../../components/notifier";

const CreateGroupModal = (props: any) => {
  const { onClose, isOpen, onSaveComplete, data } = props;
  const [titleForm, setTitleForm] = useState<string>();
  const [saveLabel, setSaveLabel] = useState<string>();

  const handleOnSubmit = async (values: any) => {
    var fields = {
      description: values.description,
      displayName: "QLTL_" + values.displayName,
      groupTypes: ["Unified"],
      mailEnabled: true,
      mailNickname: values.mailNickname.toLowerCase(),
      securityEnabled: false,
    };
    const updates = {
      description: values.description,
      displayName: "QLTL_" + values.displayName,
    };
    let result: any = null;
    try {
      result = data.id
        ? await GroupsOfficeService.updateGroup(data.id, updates)
        : await GroupsOfficeService.addGroup(fields);
    } catch (error) {
      CreateNotification({ title: "Thông báo", body: `Nhóm đã tổn tại.`, icon: "/icons/error.png" });
    }
    onSaveComplete(result);
    onClose();
  };

  useEffect(() => {
    let titleFormLocal: string = "";
    if (data) {
      titleFormLocal = data.id ? "Chỉnh sửa nhóm" : "Thêm nhóm";
      setSaveLabel(data.id ? "Cập nhật" : "Thêm");
      setTitleForm(titleFormLocal);
    }
  }, [data]);

  return (
    <Modal size="lg" show={isOpen} onHide={onClose} centered className="edit-department-detail-modal">
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={{
          id: data?.id || "",
          displayName: data?.displayName || "",
          description: data?.description || "",
          mailNickname: data?.mailNickname || null,
        }}
      >
        {({ handleSubmit, setFieldValue, handleChange, isValid, values, errors }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>{titleForm}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-4 px-4">
              <Form.Group as={Row} controlId="validationCustom01">
                <Col xs={2} className="px-1">
                  <LabelWithValue label={"Tên nhóm"} value={""} />
                </Col>
                <Col xs={1}>
                  <LabelWithValue label={"QLTL_"} value={""} />
                </Col>
                <Col xs={9}>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="displayName"
                    value={values.displayName.replace("QLTL_", "")}
                    onChange={handleChange}
                    isInvalid={!!errors.displayName}
                  />
                  <Form.Control.Feedback type="invalid">{errors.displayName}</Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group as={Row} controlId="validationCustom02">
                <Col xs={3}>
                  <LabelWithValue label={"Mô tả"} value={""} />
                </Col>
                <Col xs={9}>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="description"
                    value={values.description}
                    onChange={handleChange}
                    isInvalid={!!errors.description}
                  />
                  <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
                </Col>
              </Form.Group>

              {data && data.id ? (
                <></>
              ) : (
                <>
                  <Form.Group as={Row}>
                    <Col xs={3}>
                      <LabelWithValue label={"Email Group"} value={""} />
                    </Col>
                    <Col xs={7}>
                      <Form.Control
                        type="text"
                        placeholder=""
                        name="mailNickname"
                        value={values.mailNickname}
                        onChange={handleChange}
                        isInvalid={!!errors.mailNickname}
                      />
                      <Form.Control.Feedback type="invalid">{errors.mailNickname}</Form.Control.Feedback>
                    </Col>
                    <Col xs={2}>
                      <LabelWithValue label={"@viags.vn".toLowerCase()} value={""} />
                    </Col>
                  </Form.Group>
                  {/* <Form.Group as={Row}>
                                            <Form.Label column sm={3} className="card-label">Thành viên</Form.Label>
                                            <Col sm={9}>
                                                    <PeoplePicker className="people-picker" type={PersonType.any}  selectionChanged={handleSectionChange}/>
                                            
                                            </Col>
                                    </Form.Group> */}
                </>
              )}
            </Modal.Body>
            <Modal.Footer className="px-4">
              <Button onClick={onClose} variant="secondary">
                Đóng
              </Button>
              <Button disabled={!isValid} type="submit" variant="info">
                {saveLabel}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CreateGroupModal;
